// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityOverviewSlice from './SecurityOverviewSlice';
// css
import '../../styles/components/analytics/SecurityOverviewSlices.scss';


const SecurityOverviewSlices = ({ data }) => {
  return (
    <div className='analytics__security-overview-slices'>
      <div className='analytics__security-overview-critical-correlations'>
        <h4>Critical Correlations</h4>

        <div className='row'>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='critical'
              adequacy='acceptable'
            />
          </div>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='critical'
              adequacy='rudimentary'
            />
          </div>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='critical'
              adequacy='inadequate'
            />
          </div>
        </div>
      </div>
      <div className='analytics__security-overview-non-critical-correlations'>
        <h4>Non-Critical Correlations</h4>
        <div className='row'>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='nonCritical'
              adequacy='acceptable'
            />
          </div>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='nonCritical'
              adequacy='rudimentary'
            />
          </div>
          <div className='col-md-4'>
            <SecurityOverviewSlice
              data={data}
              criticality='nonCritical'
              adequacy='inadequate'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

SecurityOverviewSlices.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityOverviewSlices;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityOverviewSlices.js